import y from "./extends5.mjs";
function T(l, t) {
  if (process.env.NODE_ENV === "production")
    return () => null;
  const n = t ? y({}, t.propTypes) : null;
  return (o) => (e, r, s, p, u, ...d) => {
    const c = u || r, f = n?.[c];
    if (f) {
      const i = f(e, r, s, p, u, ...d);
      if (i)
        return i;
    }
    return typeof e[r] < "u" && !e[o] ? new Error(`The prop \`${c}\` of \`${l}\` can only be used together with the \`${o}\` prop.`) : null;
  };
}
export {
  T as default
};
//# sourceMappingURL=requirePropFactory.mjs.map
